import { Auth } from "aws-amplify";
import { Pages } from "../constants/enums";
import useAccount from "./useAccount";
import useApp from "./useApp";
import useFeature from "./useFeature";
import useConcept from "./useConcept";
import { DataStore } from "aws-amplify";
import { ListingByAccountVariables } from "../models/app";

const useAuth = () => {
  const { showError, showConfirm, setSession, clearSession, navigateTo } =
    useApp();
  const { accountsFetchByDomainOnline } = useAccount("accounts", "account");
  const { featuresFetchAll } = useFeature("features", "feature");
  const { conceptsFetch, conceptsChangeListing } = useConcept(
    "concepts",
    "concept"
  );

  async function register(data: any) {
    try {
      await Auth.signUp({
        username: `${data.email}`,
        password: data.password,
        attributes: {
          name: data.name,
          email: `${data.email}`,
        },
      });

      navigateTo("/");
    } catch (err: Error | any) {
      showError(
        typeof err.message === "string" ? err.message : "Error Occurred"
      );
      console.log("error signing up:", err);
    }
  }

  async function login(data: any) {
    try {
      const user = await Auth.signIn({
        username: `${data.email}`,
        password: data.password,
      });

      const session = user.signInUserSession.idToken.payload;
      setSession(session);

      DataStore.start();

      const account = await accountsFetchByDomainOnline(session);

      const listingByAccountParams: ListingByAccountVariables = {
        accountID: account ? account.id : "",
        searchText: "",
        startIndex: 0,
        limit: 1000,
      };

      const resultData: any[] = await Promise.all([
        conceptsFetch(listingByAccountParams),
        featuresFetchAll({}),
      ]);

      const concepts = resultData[0];
      const features = resultData[1];

      conceptsChangeListing(concepts);
    } catch (err: Error | any) {
      showError(
        typeof err.message === "string" ? err.message : "Error Occurred"
      );
      console.log("error signing in", err);
    }
  }

  async function logout() {
    try {
      await Auth.signOut();

      clearSession();
      navigateTo("/");
    } catch (err: Error | any) {
      showError(
        typeof err.message === "string" ? err.message : "Error Occurred"
      );
      console.log("error signing out: ", err);
    }
  }

  async function forgetPassword(data: any) {
    try {
      // Send confirmation code to user's email
      await Auth.forgotPassword(`${data.email}`);
      showConfirm("Verification code has been sent to your email.");
      navigateTo(`/${Pages.RESET_PASSWORD}`);
    } catch (err: Error | any) {
      showError(
        typeof err.message === "string" ? err.message : "Error Occurred"
      );
      console.log("error sending code to email: ", err);
    }
  }

  async function forgetPasswordSubmit(data: any) {
    try {
      const resetPassword = await Auth.forgotPasswordSubmit(
        `${data.email}`,
        data.code,
        data.newPassword
      );
      return resetPassword;
    } catch (err: Error | any) {
      showError(
        typeof err.message === "string" ? err.message : "Error Occurred"
      );
      console.log(err);
    }
  }

  return { login, register, logout, forgetPassword, forgetPasswordSubmit };
};

export default useAuth;
